const TranslationScope = {
    FOR_WEB: 'for-web',
    FOR_APP: 'for-app'
};

export default TranslationScope;
